import Rights from "./rights";

export default Rights;